import { Analytics, Performance } from './analytics'
import mustache from 'mustache'

export const globalNamespace: any = global

globalNamespace.mustache = mustache

globalNamespace.CONTRAST = {
  Analytics,
  Performance
}
